module.exports = __webpack_public_path__ + "static/media/ic-side-menu.3491140f.svg";